import type { ModuleMigrationDef } from "@kubdee/sdk";

const resequenceSalesInvoiceSinvSql = `
UPDATE \`sales_invoices\`
SET
  \`invoice_no\` = '__SINV_RESEQ__' || \`id\`,
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`invoice_type\` = 'sales'
  AND EXISTS (
    SELECT 1
    FROM sqlite_master
    WHERE type = 'table' AND name = 'accounting_invoices'
  );

UPDATE \`accounting_invoices\`
SET
  \`invoice_no\` = '__SINV_RESEQ__' || \`id\`,
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (
  SELECT \`id\`
  FROM \`sales_invoices\`
  WHERE \`invoice_type\` = 'sales'
);

WITH numbered AS (
  SELECT
    candidates.\`id\`,
    'SINV-' || COALESCE(NULLIF(substr(candidates.\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now')) || '-' || printf(
      '%05d',
      COALESCE(existing_non_target.max_seq, 0) + ROW_NUMBER() OVER (
        PARTITION BY COALESCE(NULLIF(substr(candidates.\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now'))
        ORDER BY candidates.\`invoice_date\`, candidates.\`created_at\`, candidates.\`id\`
      )
    ) AS new_invoice_no
  FROM \`sales_invoices\` candidates
  LEFT JOIN (
    SELECT
      substr(\`invoice_no\`, 6, 4) AS doc_year,
      MAX(CAST(substr(\`invoice_no\`, 11) AS INTEGER)) AS max_seq
    FROM \`accounting_invoices\`
    WHERE \`invoice_no\` LIKE 'SINV-%'
      AND length(\`invoice_no\`) = 15
      AND \`id\` NOT IN (
        SELECT \`id\`
        FROM \`sales_invoices\`
        WHERE \`invoice_type\` = 'sales'
      )
    GROUP BY substr(\`invoice_no\`, 6, 4)
  ) existing_non_target
    ON existing_non_target.doc_year = COALESCE(NULLIF(substr(candidates.\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now'))
  WHERE candidates.\`invoice_type\` = 'sales'
)
UPDATE \`accounting_invoices\`
SET
  \`invoice_no\` = (SELECT numbered.new_invoice_no FROM numbered WHERE numbered.\`id\` = \`accounting_invoices\`.\`id\`),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (SELECT \`id\` FROM numbered);

UPDATE \`sales_invoices\`
SET
  \`invoice_no\` = (
    SELECT \`accounting_invoices\`.\`invoice_no\`
    FROM \`accounting_invoices\`
    WHERE \`accounting_invoices\`.\`id\` = \`sales_invoices\`.\`id\`
  ),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (
  SELECT \`id\`
  FROM \`accounting_invoices\`
  WHERE \`invoice_type\` = 'sales'
    AND \`invoice_no\` LIKE 'SINV-%'
    AND length(\`invoice_no\`) = 15
);

WITH current_year_max AS (
  SELECT COALESCE(MAX(CAST(substr(\`invoice_no\`, 11) AS INTEGER)), 0) AS max_seq
  FROM \`sales_invoices\`
  WHERE \`invoice_type\` = 'sales'
    AND substr(\`invoice_no\`, 6, 4) = strftime('%Y', 'now')
    AND \`invoice_no\` LIKE 'SINV-%'
    AND length(\`invoice_no\`) = 15
)
UPDATE \`core_numbering_series\`
SET
  \`prefix\` = 'SINV-{YYYY}-#####',
  \`current_value\` = (SELECT max_seq FROM current_year_max),
  \`reset_every\` = 'yearly',
  \`last_reset_year\` = CAST(strftime('%Y', 'now') AS INTEGER),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`module\` = 'sales'
  AND \`doctype\` = 'sales_invoice'
  AND \`is_default\` = 1
  AND ((SELECT max_seq FROM current_year_max) > 0 OR \`prefix\` <> 'SINV-{YYYY}-#####');
`.trim();

// Runs under a new key for tenants that completed the earlier INV migration.
export const migration: ModuleMigrationDef = {
  key: "008_resequence_sales_invoice_sinv_numbers",
  version: "1.3.4",
  ignoreErrors: ["no such table: accounting_invoices"],
  sql: resequenceSalesInvoiceSinvSql,
};
